import script from "./shareCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./shareCard.vue?vue&type=script&setup=true&lang=ts"

import "./shareCard.vue?vue&type=style&index=0&id=7c0c785b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0c785b"]])

export default __exports__